import classnames from "classnames"
import "./PathTopicDetails.css"

const PathTopicDetails = function ({ item, isArchiving }) {
  const className = classnames("PathTopicDetails", {
    "PathTopicDetails--archiving": isArchiving
  })

  return (
    <div className={className}>
      <h2 className="PathTopicDetails__title">{item.name}</h2>
    </div>
  )
}

PathTopicDetails.displayName = "PathTopicDetails"

export default PathTopicDetails
